import { heroFeatures } from "@/mocks/home";

export default function HomeHero() {
  return (
    <section className="relative h-[520px] md:h-[640px] w-full flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20and%20romantic%20abstract%20gradient%20background%20with%20soft%20coral%20pink%20and%20peach%20tones%2C%20gentle%20flowing%20curves%20and%20organic%20shapes%2C%20dreamy%20atmospheric%20lighting%20with%20warm%20golden%20accents%2C%20elegant%20and%20minimal%20composition%2C%20modern%20Chinese%20community%20website%20aesthetic%2C%20soft%20bokeh%20effects%2C%20smooth%20gradients&width=1920&height=800&seq=hero-bg-2026&orientation=landscape"
        alt="爱情岛论坛背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
            <i className="ri-heart-fill text-primary-400 text-sm"></i>
            <span className="text-white/90 text-sm font-medium">温暖有爱的社区交流平台</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
            欢迎来到<span className="text-primary-400">爱情岛论坛</span>
          </h1>
          <p className="text-white/75 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
            爱情岛论坛网站是广受用户喜爱的交流社区平台。无论你是寻找情感共鸣、生活灵感，
            还是想结识志同道合的朋友，这里都有属于你的一片天地。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
            <a
              href="/category/qinggan-jiaoliu"
              className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-8 py-3.5 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              <i className="ri-compass-3-line mr-2"></i>探索论坛
            </a>
            <a
              href="/about"
              className="w-full sm:w-auto bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium px-8 py-3.5 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/20"
            >
              <i className="ri-information-line mr-2"></i>了解更多
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
            {heroFeatures.map((feat) => (
              <div key={feat.text} className="flex items-center gap-2 text-white/70">
                <i className={`${feat.icon} text-primary-400 text-lg`}></i>
                <span className="text-sm font-medium">{feat.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}